import React from 'react'
import {NavLink} from 'react-router-dom'

import Mmgletters from './img/mmg-letters.png'

const Privacy = () => (

  <div id="standard-content">

    <div id="logo-header">
      <img src={Mmgletters} alt="Mmg" />
    </div>

    <NavLink className="backlink" exact to="/">Back</NavLink>

    <h1>Privacy Policy and GDPR</h1>

      <p>
          Any organisation established in the EU and processing personal data of
          EU-based individuals are required to comply with the GDPR by May 25, 2018.
          The GDPR updates the framework for processing personal data in the EU, and
          brings with it new requirements for companies and new rights for
          individuals.
      </p>
      <h2>Our Commitment</h2>
      <p>
          The team at Make Moore and Groove is fully committed to complying with the
          requirements of the GDPR. Our policy team have closely analyzed the
          requirements of the GDPR and continue to monitor new guidance on best
          practices for implementing the requirements of the GDPR. We have taken
          these new requirements and made changes to our policies to ensure that we
          are fully in compliance with the GDPR.
      </p>
      <h2>Privacy policy for Make Moore and Groove Ltd</h2>
      <p>
          Make Moore and Groove Ltd take the privacy of our clients and candidates
          seriously. We are an an organisation that connects the Marketing and
          Communications industry via the services of recruitment and lead
          generation.
      </p>
      <h2>How we use the information we receive (and how we receive it)</h2>
      <p>
          Make Moore and Groove will usually receive your personal data further to a
          connection made via various third party partners where publicly available
          information is held (e.g LinkedIn), a referral from a mutual contact or
          when you have sent data to us directly to either apply for a position we
          have discussed, or to be a candidate for whom we can help facilitate a job
          search for.
      </p>
      <p>
          When you provide personal details to Make Moore and Groove you are
          consenting to us collecting and storing your personal information. In our
          correspondence to you we will clearly state the basis of this consent and
          provide links to this policy. We will also hold any data that you have
          consented to make publicly available via third party platforms that have
          been specifically designed to enable two parties to connect for such
      reasons as recruitment support or lead generation such as LinkedIn (<a href="http://www.linkedin.com/">www.linkedin.com</a>) or Lusha (    <a href="http://www.lusha.co/">www.lusha.co</a>). This may include but is
          not restricted to your name; contact details; address; employment history
          and education.
      </p>
      <p>
          During telephone conversations and face to face interviews we may collect
          personal information with regard to employment preferences, salary details,
          notice period, and work experience which may be stored on your personal
          record. This information facilitates our ability to support your job search
          and to provide a basis for recommendation when short-listing candidates for
          a particular role. By providing this information to Make Moore and Groove
          you are consenting to us storing this information to assist you in current
          or future job searches. Make Moore and Groove will never share personal
          information or a Curriculum Vitae with a third party without your explicit
          consent.
      </p>
      <p>
          Due to the nature of the recruitment work we do, a significant number of
          candidates and clients reconnect with our organisation periodically. It is
          not uncommon for this to occur years after we have placed them in a role,
          helped them hire talent or made mutually beneficial business introductions.
          For this reason, your consent includes us being able to retain your
          personal details until such time as you wish us to delete your records from
          our database or refrain from further engagement. You will have the
          opportunity to have your details removed at any time you wish and can e
          mail <a>remove@makemooreandgroove.co.uk</a> to request this.
      </p>
      <p>
          If you do not consent to Make Moore and Groove storing your personal data
          or setting up a personal registration for you, please do not submit your CV
          or any of the information in addition to that already publicly available
          that we have mentioned in this policy.
      </p>
      <br/>
      <h2>Job notifications and career advice</h2>
      <p>
          We may on occasion make contact with candidates and clients stored in our
          database or on publically available career and business purpose platforms
          who are not actively looking for a new role or have contacted us about a
          recruitment or lead generation requirement. When you make direct contact
          with Make Moore and Groove in response with any data, or for that matter
          have this information available via publicly accessible third party
          platforms (e.g LinkedIn or Lusha) you are indicating that you are happy for
          businesses to have access (and to store) the information you have provided.
          If you do not wish any of this information to be openly available, you
          should contact the specific platforms, or Make Moore and Groove and ask to
          have your data removed. By consenting to having your information publicly
          available or by sending this to Make Moore and Groove you are also
          consenting to our storage of your personal data and consent to us
          contacting you if we receive details of a role which matches your skillset,
          career aspirations or business requirements.
      </p>
      <p>
          If you do not wish to receive such information, please email
          gdprcompliance@makemooreandgroove.co.uk
      </p>
      <h2>Our promise</h2>
      <p>
          We will never share our candidates’ personal details, Curriculum Vitae or
          business sensitive information with any third party without the candidate’s
          explicit consent, and then we will only share the personal information with
          that one company or individual. We will never share any information with a
          third party unless previously agreed, or the same information is available
          publically at that time and all our intertations will have a specific,
          rather than speculative agenda.
      </p>
      <h2>Contacting us</h2>
      <p>
          If you contact our staff directly and request they consult with you
          regarding your job search, ask for general advice , discuss details around
          business objectives or regarding a particular job role, you are giving your
          consent to Make Moore and Groove to process and store this information
          shared for specific and lawful purposes related to the nature of the
          engagement.
      </p>
      <h2>Referrals</h2>
      <p>
          If you share any data with Make Moore and Groove about any 3rd party (e.g
          refer a friend) you are confirming that you have obtained permission from
          that individual to share this information on the premise it will be stored
          by us for the purpose of the introduction and future related use.
      </p>
      <h2>Request to have personal data amended or removed</h2>
      <p>
          It is likely that over time your data will require updating as you
          transition to new roles or receive promotion. Make Moore and Groove
          undertake to update your registration within 2 weeks of receiving any
          updated information.
      </p>
      <p>
          Under the GDPR you have the right to ask for access to your personal
          information at any time and can do so by emailing
          gdprcompliance@makemooreandgroove.co.uk . In the unlikely event you find
          personal data stored is inaccurate, you must advise us immediately. We will
          amend your personal registration within two weeks
      </p>
      <p>
          Upon receipt of a request to delete an individual’s personal registration
          or data, we will ensure that your personal record is deleted within 30
          days.
      </p>
      <h2>Storing of Data</h2>
      <p>
          We are aware of our responsibility as a recruitment company and lead
          generation business to protect your information and to only share details
          with third parties upon receipt of your explicit consent. All of our
          systems are protected to GDPR standard and only Make Moore and Groove staff
          have access to the personal information stored in your registration, all of
          which is password protected to GDPR standards.
      </p>
      <p>
          In the unlikely event that our computer systems are compromised and there
          is a potential loss of confidentiality we will report this breach to you.
      </p>
      <h2>Complaints procedure</h2>
      <p>
          If you have a complaint about the way your data is stored or handled by
          Make Moore and Groove Ltd , please contact us at:
          <a href="mailto:GDPRCompliance@makemooreandgroove.co.uk">GDPRCompliance@makemooreandgroove.co.uk</a>
      </p>
      <p>
          Alternatively you can contact us by writing to us at:
      </p>
      <p>
          GDPR Compliance Officer<br/>
          Make Moore and Groove Ltd<br/>
          Worklife, 20 Jerusalem Passage<br/>
          Clerkenwell, London EC1V 4JP
      </p>
      <p>
          If you remain unhappy with the handling of your data you can complain to
          the ICO.
      </p>
      <p>
          Information Commissioner’s Office
      </p>
      <p>
          Wycliffe House, Water Lane<br/>
          Wilmslow<br/>
          Cheshire<br/>
          SK9 5AF<br/>
      </p>
      <h2>Changes to our Privacy Policy</h2>
      <p>
          This privacy policy may be changed by Make Moore and Groove at any time.
          Any changes to our Privacy Policy will be updated on our website. If you
          have any questions or concerns, please email us at
          <a href="mailto:GDPRCompliance@makemooreandgroove.co.uk">GDPRCompliance@makemooreandgroove.co.uk</a>
      </p>

      <NavLink className="backlink" exact to="/">Back</NavLink>

  </div>


);


export default Privacy;
